import React from 'react'

export const HouseSizeXSIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='81'
      height='53'
      viewBox='0 0 81 53'
      fill='none'>
      <path
        d='M79.0742 51.9928H1.07422'
        stroke='#3B4768'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M71.5451 51.9964H8.60327V12.5L39.5 1L71.5451 12.5V51.9964Z'
        fill='white'
        stroke='#3B4768'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.84058 13.7991L39.5 1L75.3079 13.7991'
        stroke='#3B4768'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M75.3115 48.2336H4.84058V52H75.3115V48.2336Z'
        fill='white'
        stroke='#3B4768'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M37.4718 21.1732H22.677V47.5844H37.4718V21.1732Z'
        fill='white'
        stroke='#3B4768'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M25.6567 33.5002V36.1482'
        stroke='#3B4768'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M61.4258 16.4993H49.4258V30.4993H61.4258V16.4993Z'
        fill='white'
        stroke='#3B4768'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
